<script>
import i18n from '@/plugins/i18n';

export default {
    props: {
        Item: {
            type: Object,
            required: true,
        },

        ShowEraseData: {
            type: Boolean,
            default: false,
        }
    },

    data() {
        return {
            action: null,
        }
    },

    computed: {
        FIELDS() {
            const erase_data = this.ShowEraseData ? ['erased_by_name', 'erased_on'] : [];

            return [
                'name',
                'full_directory',
                'type',
                'size',
                'created_by_name',
                'created_on',
                'updated_by_name',
                'updated_on',
                'deleted_by_name',
                'deleted_on',
                ...erase_data,
            ];
        },

        BUTTONS() {
            return [
                {
                    key: 'delete',
                    warning_text: i18n.t('documents.warnings.delete'),
                    color: 'yellow',
                    act: () => this.$emit('action', 'delete'),
                },
                {
                    key: 'erase',
                    warning_text: i18n.t('documents.warnings.erase'),
                    color: 'red',
                    act: () => this.$emit('action', 'erase'),
                },
            ];
        },
    },

    methods: {
        SetAction(_action) {
            this.action = _action;
        },
    }
}
</script>

<template>
    <div class="document-details">
        <div v-if="Item">
            <div v-for="key in FIELDS" :key="key">
                <label :for="key" style="font-size: 1.2vw;">
                    <b>{{ $t(`documents.properties.${key}`) }}</b>
                </label>

                <div v-if="key === 'size'">
                    {{ Item[key] | bytesFormat }}
                </div>
                <div v-else-if="key.includes('ed_on')">
                    {{ Item[key] | dateFormat }}
                </div>
                <div v-else>
                    {{ 
                        Item[key] != null && Item[key] != 'null null' ?
                        Item[key] : 
                        '-'
                    }}
                </div>
            </div>
        </div>
        
        <div v-if="Item">
            <div v-for="button in BUTTONS" :key="button.key" class="button-container">
                <button  
                    class="sust-btn" :class="`sust-btn-${button.color}`"
                    @click="SetAction(button)"
                >
                    {{ $t(`documents.actions.${button.key}`) }}
    
                </button>

                <div v-if="action && action.key === button.key">
                    <div>
                        {{ button.warning_text }}
                    </div>
                    <div>
                        {{ $t('documents.warnings.proceed') }}
                    </div>
                    <div>
                        <button class="sust-btn sust-btn-red" @click="SetAction(null)">
                            {{ $t('misc.cancel') }}
                        </button>
                        <button class="sust-btn sust-btn-green" @click="button.act()">
                            {{ $t('misc.ok') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div v-else>
            An error occurred when trying to fetch the details!
        </div>
    </div>
</template>

<style lang='scss' scoped>
    .document-details {
        padding: .1em;
        max-width: 40vw;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        > div {
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: stretch;
            align-content: center;
            flex-wrap: wrap;
            
            > div {
                width: 40%;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: flex-start;
                text-align: left;
                margin: 1em 2.5%;

                > label {
                    margin-bottom: .25em;
                }
            }

            > button {
                width: 40%;
                margin: 1em 2.5%;
            }
        }
    }

    .button-container {
        position: relative;

        > div {
            z-index: 999999;
            position: absolute;
            top: -7px;
            left: 0px;
            transform: translate(-10%, -100%);
            text-align: left !important;
            background-color: var(--sustainfinity-faded-blue-even-darker);
            width: 15vw;

            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;

            padding: .25em .25em 0 .25em;
            border: thin solid var(--carbon);
            border-radius: .3em;

            > div {
                margin-bottom: .3em;
                &:first-of-type {
                    color: var(--invalid-input);
                    font-size: .9vw;
                }
                &:nth-of-type(2){
                    color: var(--carbon);
                    font-size: .9vw;
                }
                &:nth-of-type(3) {
                    width: 100%;
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-end;
                    align-items: flex-start;
                    
                    > button {
                        margin-left: .5em;
                        min-width: 0 !important;
                        max-width: fit-content !important;
                        font-size: .75vw;
                    }
                }
            }

            &::after {
                content: "";
                position: absolute;
                width: 0;
                height: 0;
                border-style: solid;
            }

            &::after {
                bottom: -6px;
                left: 50%;
                margin-left: -6px;
                border-width: 6px 6px 0 6px;
                border-color: rgba(2, 48, 71, .75) transparent transparent transparent;
            }
        }
    }
</style>